// extracted by mini-css-extract-plugin
module.exports = {"form":"EmailForm_form__n5etr","input":"EmailForm_input__1aHVW","error":"EmailForm_error__11U11","button":"EmailForm_button__3ezaP","errorMessage":"EmailForm_errorMessage__3PO7w"};